import script from "./DataLink.vue?vue&type=script&setup=true&lang=js"
export * from "./DataLink.vue?vue&type=script&setup=true&lang=js"

import "./DataLink.vue?vue&type=style&index=0&id=532c8c4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-532c8c4a"]])

export default __exports__